// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VqAeC","input":"styles_input__77PBT"};